(function (Drupal, once) {

  const activeClass = 'active';
  let doormatActive = false;

  Drupal.behaviors.vlizDoormat = {
    attach(context, settings) {

      const triggers = once('doormat-triggers', 'header [data-doormat-target]');
      const targetElements = once('doormat-targets', '[data-doormat-id]');

      const clearNavClasses = () => {
        triggers.forEach((item) => {
          item.classList.remove(activeClass);
        });
      }

      const clearActiveDoormats = () => {
        targetElements.forEach((item) => {
          item.classList.remove(activeClass);
        });
      }

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', (ev) => {
          ev.preventDefault();
          clearNavClasses();

          targetElements.forEach((doormatContainer) => {
            if (doormatContainer.dataset.doormatId == trigger.dataset.doormatTarget) {

              if (doormatContainer.classList.contains(activeClass)) {
                doormatActive = false;
                doormatContainer.classList.remove(activeClass);
                trigger.classList.remove(activeClass);
              } else {
                doormatActive = true;
                doormatContainer.classList.add(activeClass);
                trigger.classList.add(activeClass);
              }

            } else {
              doormatContainer.classList.remove(activeClass);
            }
          });
        });
      });

      // close all when mouse doesn't click the header region (or its children)
      document.addEventListener('click', (e) => {
        if (doormatActive && !e.target.closest('header')) {
          clearNavClasses();
          clearActiveDoormats();
        }
      });

    }
  };

}(Drupal, once));
